import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
const StyledLabel = styled.label `
    display: block;
    color: ${props => props.theme.primary.base};
    font-size: 15px;
    font-weight: ${props => (props.activeFilter ? '700' : '400')};
    margin-bottom: ${props => props.marginBottom};

    ${props => props.required &&
    css `
            &:after {
                content: '*';
                color: #bf3939;
                padding-left: 5px;
                font-size: 16px;
            }
        `}
`;
const InputLabel = ({ children, marginBottom, activeFilter, ...restProps }) => (_jsx(StyledLabel, { marginBottom: marginBottom, activeFilter: activeFilter, ...restProps, children: children }));
export default InputLabel;
